// extracted by mini-css-extract-plugin
module.exports = {"noop":"Chip_noop__2dR8M","chip":"Chip_chip__3ie1J"};